import { useEffect, useState } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ArticleCard from "@/components/ArticleCard";
import { api } from "@/lib/api";
import { applySeo } from "@/lib/seo";

export default function BlogList() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
    applySeo({
      title: "Blog – Grüne Geldanlage",
      description: "Artikel und Analysen zu nachhaltigen Geldanlagen: ESG, grüne ETFs, Impact Investing, Regulierung und Greenwashing.",
      canonicalPath: "/blog",
    });
  }, []);

  return (
    <div className="min-h-screen bg-brand-paper">
      <Header />
      <section className="max-w-4xl mx-auto px-6 lg:px-10 pt-20 pb-14" data-testid="blog-intro">
        <div className="overline mb-4">Blog</div>
        <h1 className="font-serif text-5xl md:text-6xl font-light leading-tight tracking-tight text-brand-dark mb-8">
          Artikel, Analysen und Prüfanleitungen.
        </h1>
        <div className="prose-editorial max-w-none">
          <p>
            Der Blog von Grüne Geldanlage bündelt journalistische Beiträge rund um nachhaltige
            Geldanlagen im deutschsprachigen Raum. Wir schreiben für Privatanleger, die
            verstehen möchten, was hinter ESG-Etiketten steckt und wie sich ein sinnvolles
            Portfolio zwischen Rendite, Regulierung und ökologischer Wirkung aufbauen lässt.
          </p>
          <p>
            Thematisch decken wir das gesamte Feld ab: Grundlagenartikel erklären
            ESG-Kriterien, Rating-Methodiken und regulatorische Vorgaben wie EU-Taxonomie und
            SFDR-Offenlegungsverordnung. Vergleichs- und Produktanalysen ordnen konkrete
            Anlagevehikel ein – von nachhaltigen ETFs über aktiv gemanagte grüne Fonds bis zu
            Green Bonds und Impact-Investments. Praxisartikel liefern Prüfroutinen gegen
            Greenwashing, erklären den Umgang mit Wirkungsberichten und zeigen, welche
            unabhängigen Prüfsiegel im deutschsprachigen Raum Orientierung geben. Ergänzt wird
            das Themenspektrum durch Beiträge zu Steuerthemen, sparplanfähigen Produkten und
            Portfoliostrategien.
          </p>
          <p>
            Die Themen wählt die Redaktion nach zwei Kriterien aus: Relevanz für Privatanleger
            und Reife des Sachstands. Wir greifen Themen auf, sobald es belastbare Daten,
            Studien oder regulatorische Klarheit gibt – nicht schon dann, wenn eine
            Pressemitteilung erscheint. Jeder Artikel durchläuft eine mehrstufige Recherche mit
            Quellenprüfung: Wir verwenden Primärquellen (Fondsprospekte,
            Regulierungsdokumente, wissenschaftliche Studien) und ergänzen sie durch mehrere
            unabhängige Sekundärquellen. Marketing-Material von Anbietern nutzen wir
            grundsätzlich nicht als Beleg.
          </p>
          <p>
            Neue Artikel erscheinen im redaktionellen Rhythmus – üblicherweise mehrere Beiträge
            im Monat, ergänzt durch Aktualisierungen bestehender Texte, wenn sich Rechtslage
            oder Marktumfeld ändern. Wir arbeiten bewusst ohne täglichen Newsdruck: Ein Thema
            erscheint erst dann als Artikel, wenn wir es einordnen können. Wenn Sie einen
            konkreten Themenvorschlag haben – etwa ein Produkt, das Sie geprüft haben möchten,
            oder ein Regulierungsdetail, das Ihnen Fragen aufwirft – erreichen Sie uns über die
            im Impressum genannte Kontaktadresse.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24" data-testid="blog-grid">
        <div className="grid md:grid-cols-2 gap-14">
          {articles.map((a, i) => (
            <ArticleCard key={a.id} article={a} featured={i === 0} />
          ))}
        </div>
        {articles.length === 0 && (
          <p className="text-neutral-500 text-center py-20">Artikel werden geladen…</p>
        )}
      </section>
      <Footer />
    </div>
  );
}
